import { Reveal, SectionLabel } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const GALERIE_VIDEOS = [
  { src: "/media/galerie-v1.mp4", poster: "/media/poster-galerie-v1.jpg", caption: "Séance — lagon" },
  { src: "/media/galerie-v2.mp4", poster: "/media/poster-galerie-v2.jpg", caption: "Flottaison — bassin privé" },
  { src: "/media/galerie-v3.mp4", poster: "/media/poster-galerie-v3.jpg", caption: "Immersion douce" },
  { src: "/media/galerie-v4.mp4", poster: "/media/poster-galerie-v4.jpg", caption: "La magie de l'eau" },
  { src: "/media/galerie-v5.mp4", poster: "/media/poster-galerie-v5.jpg", caption: "Séance — eau ouverte" },
  { src: "/media/galerie-v6.mp4", poster: "/media/poster-galerie-v6.jpg", caption: "Instants de séance" },
  { src: "/media/galerie-v7.mp4", poster: "/media/poster-galerie-v7.jpg", caption: "Lâcher-prise" },
  { src: "/media/galerie-v8.mp4", poster: "/media/poster-galerie-v8.jpg", caption: "Vagues et respiration" },
  { src: "/media/galerie-v9.mp4", poster: "/media/poster-galerie-v9.jpg", caption: "Séance partagée" },
  { src: "/media/galerie-v10.mp4", poster: "/media/poster-galerie-v10.jpg", caption: "Dans le mouvement de l'eau" },
  { src: "/media/galerie-v11.mp4", poster: "/media/poster-galerie-v11.jpg", caption: "Présence — main dans la main" },
];

export default function Galerie() {
  const { tr } = useLang();
  return (
    <main className="min-h-screen bg-abyss pt-[72px] pb-24" data-testid="gallery-page">
      <div className="mx-auto max-w-7xl px-5 pt-14 md:px-10">
        <Reveal>
          <SectionLabel>{tr("Galerie OJANZU")}</SectionLabel>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl font-light text-foam">
            {tr("L'eau en mouvement.")}
          </h1>
          <p className="mt-3 max-w-xl text-sm text-foam/55">
            {tr("Onze instants filmés — bassins privés, lagons et séances. Lancez la lecture, laissez l'eau faire le reste.")}
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="video-gallery">
          {GALERIE_VIDEOS.map((v, i) => (
            <Reveal key={v.src} delay={Math.min(i * 0.05, 0.3)}>
              <figure className="overflow-hidden rounded-2xl border border-aqua/15 bg-abyss/40">
                <video
                  controls
                  playsInline
                  preload="metadata"
                  poster={v.poster}
                  src={v.src}
                  data-testid={`gallery-video-${i + 1}`}
                  className="aspect-[9/16] w-full object-cover"
                />
                <figcaption className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.18em] text-foam/50">
                  {tr(v.caption)}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}